import React, { useState, useEffect, useMemo } from "react";
import {
  Row,
  Card,
  CardBody,
  Input,
  CardTitle,
  FormGroup,
  Label,
  Form,
} from "reactstrap";
import TeamanicsButton from "../../../../../buttoncomponent/TeamanicsButton";
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import { useHistory, useLocation } from "react-router-dom";
import countryList from "react-select-country-list";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import GooglePlacesComponent from "../../../../candidateinfo/GooglePlacesComponent";
import { ProfileService } from "../../../../../services/ProfileService";
import { Stringutility } from "../../../../../utilities/stringutility";
import { Constants } from "../../../../../constants/constantValues";

const CandidateAddEducation = () => {

  const location = useLocation();
  const receivedData = location.state;
  var educationId = "";
  if (!Stringutility.isNullOrEmpty(receivedData)) {
    educationId = receivedData.id;
  }
 
  const history = useHistory();
  const countries = useMemo(() => countryList().getData(), []);
  const [inputField, setInputField] = useState({
    majortype: "",
    school: "",
    startDate: "",
    endDate: "",
    description: "",
  });

  const [inputAddressField, setInputAddressField] = useState({
    street: "",
    area: "",
    city: "",
    state: "",
    zipcode: "",
    latitude: "",
    longitude: "",
  });

  const [country, setCountry] = useState({
    value: "US",
    label: "United States",
  });
  const [educationType, setEducationType] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [candidateSkills, setCandidateSkills] = useState([]);
  const [selectdCounty, setSelectedCountry] = useState("United States");
  const [certificationsList, setCandidateCertificationList] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [educationTypeOptions, setEducationTypeOptions] = useState([]);
  const [saveBtnEnabled, setSaveBtnEnabled] = useState(false);

  const handleCallback = (googlePlaces) => {
    setInputAddressField((prevState) => ({
      ...prevState,
      street: googlePlaces.street,
      area: googlePlaces.area,
      city: googlePlaces.city,
      state: googlePlaces.state,
      zipcode: googlePlaces.zipcode,
      latitude: googlePlaces.latitude,
      longitude: googlePlaces.longitude,
    }));
    countries.map((country) => {
      if (country.label == googlePlaces.country) {
        setCountry(country);
        setSelectedCountry(googlePlaces.country);
      }
    });
  };

  const inputsHandler = (e) => {
    const { name, value } = e.target;
    setInputField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const inputAddressHandler = (e) => {
    const { name, value } = e.target;
    setInputAddressField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCountrySelectChange = (value) => {
    setCountry(value);
    setSelectedCountry(value.label);
  };

  const handleEducationSelectChange = (e) => {
    setEducationType(e.target.value);
  };

  const close = () => {
    history.goBack();
  };

  const handleSkillCheck = (event, skill, index) => {
    var updatedList = [...selectedSkills];
    if (event.target.checked) {
      updatedList.push(skill.skillId);
    } else {
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i] == skill.skillId) {
          updatedList.splice(i, 1);
        }
      }
    }
    setSelectedSkills(updatedList);
  };

  const handleCerificationCheck = (event, skill, index) => {
    var updatedList = [...selectedSkills];
    if (event.target.checked) {
      updatedList.push(skill.skillId);
    } else {
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i] == skill.skillId) {
          updatedList.splice(i, 1);
        }
      }
    }
    setSelectedSkills(updatedList);
  };

  let count = 0;
  useEffect(() => {
    
    if (window.localStorage.getItem("enumsLists")!=null) {
      var enumsLists = JSON.parse(window.localStorage.getItem("enumsLists"));
      if (enumsLists.eduTypes !== null) {
        setEducationTypeOptions(enumsLists.eduTypes);
      }
    }
    if (educationId) {
      getEducationDetails(educationId);
    }
    getCandidateSkillList();
    getTotalCandidateCertificationsList();
  }, [count]);

  const getTotalCandidateCertificationsList = () => {
    ProfileService.getProfileCertifications().then((response) => {
      try {
        if (response.data != null) {
          setCandidateCertificationList(response.data.skills);
        }
      } catch (err) {
        console.error("getProfileCertifications" + JSON.stringify(err));
      }
    });
  };

  const getCandidateSkillList = () => {
    ProfileService.getProfileSkills().then((response) => {
      try {
        if (response.data != null) {
          const candidateSkills=response.data.skills;          
          if(candidateSkills!=null){
            setCandidateSkills(candidateSkills);
          }          
        }
      } catch (err) {
        console.error("getProfileSkills" + JSON.stringify(err));
      }
    });
  };

  const getEducationDetails = () => {
    ProfileService.getCandidateEducation(educationId).then((response) => {
      try {
        if (response.data != null) {
          var educationDetails = response.data;
          if (educationDetails.educationType !== null) {
            setEducationType(educationDetails.educationType.key);
          }

          let major = educationDetails.major;
          let school = educationDetails.school;
          let description = educationDetails.description;
          setInputField((prevState) => ({
            ...prevState,
            majortype: Stringutility.getValue(major),
            school: Stringutility.getValue(school),
            description: Stringutility.getValue(description),
          }));

          if (!Stringutility.isNullOrEmpty(educationDetails.startDate)) {
            if (educationDetails.startDate > 0) {
              setStartDate(new Date(educationDetails.startDate));
            } else if (educationDetails.startDate == 0) {
              setStartDate();
            }
          }

          if (!Stringutility.isNullOrEmpty(educationDetails.endDate)) {
            if (educationDetails.endDate > 0) {
              setEndDate(new Date(educationDetails.endDate));
            } else if (educationDetails.endDate == 0) {
              setEndDate();
            }
          }
          var address = educationDetails.address;
          if (address !== null) {
            let city = address.city;
            let state = address.state;
            let zipcode = address.zipcode;
            let latitude = address.latitude;
            let longitude = address.longitude;
            setInputAddressField((prevState) => ({
              ...prevState,
              city: Stringutility.getValue(city),
              state: Stringutility.getValue(state),
              zipcode: Stringutility.getValue(zipcode),
              latitude: Stringutility.getValue(latitude),
              longitude: Stringutility.getValue(longitude),
            }));

            let addressCountry = address.country;
            if (!Stringutility.isNullOrEmpty(addressCountry)) {
              countries.map((country) => {
                if (country.label == addressCountry) {
                  setCountry(country);
                  setSelectedCountry(addressCountry);
                }
              });
            }
          }

          if (response.data.skills !== null) {
            var list = [...selectedSkills];
            response.data.skills.length > 0 &&
              response.data.skills.map((skill) => {
                list.push(skill.skillId);
              });
            setSelectedSkills(list);
          }
        }
      } catch (err) {
        console.error("getCandidateEducation" + JSON.stringify(err));
      }
    });
  };

  const submitButton = () => {
    if (Stringutility.getValue(educationType) == "") {
      Stringutility.showErrorMessage(Constants.selectEducationType);
      return;
    }

    let majorType = inputField.majortype;
    if (Stringutility.getValue(majorType) == "") {
      Stringutility.showErrorMessage(Constants.enterMajor);
      return;
    }

    let school = inputField.school;
    if (Stringutility.getValue(school) == "") {
      Stringutility.showErrorMessage(Constants.enterSchoolName);
      return;
    }

    if (Stringutility.getValue(endDate) == "") {
      Stringutility.showErrorMessage(Constants.enterEndDate);
      return;
    }

    if (endDate > 0) {
      var start_date = new Date(startDate).getTime();
      var end_date = new Date(endDate).getTime();

      if (start_date > end_date) {
        Stringutility.showErrorMessage(Constants.endDateGraterThanStartDate);
        return;
      }
    }

    let city = inputAddressField.city;
    if (Stringutility.getValue(city) == "") {
      Stringutility.showErrorMessage(Constants.enterCity);
      return;
    }

    let state = inputAddressField.state;
    if (Stringutility.getValue(state) == "") {
      Stringutility.showErrorMessage(Constants.enterState);
      return;
    }

    if (selectdCounty == "") {
      Stringutility.showErrorMessage(Constants.selectCountry);
      return;
    }

    const moAddress = {
      city: city,
      state: state,
      country: selectdCounty,
      zipcode: inputAddressField.zipcode,
      latitude: inputAddressField.latitude,
      longitude: inputAddressField.longitude,
    };

    const addEducationReqest = {
      educationType: educationType,
      major: majorType,
      school: school,
      startDate: new Date(startDate).getTime(),
      endDate: new Date(endDate).getTime(),
      description: inputField.description,
      address: moAddress,
      skills: selectedSkills,
    };

    if (educationId !== "") {
      setSaveBtnEnabled(true);
      ProfileService.updateEducationDetails(
        addEducationReqest,
        educationId
      ).then((response) => {
        setSaveBtnEnabled(false);
        try {
          // toast.success("Education updated successfully");
          history.goBack();
        } catch (err) {
          console.error("updateEducationDetails" + JSON.stringify(err));
        }
      });
    } else {
      setSaveBtnEnabled(true);
      ProfileService.addEducationDetails(addEducationReqest).then(
        (response) => {
          setSaveBtnEnabled(false);
          try {
            // toast.success("Education added successfully");
            history.goBack();
          } catch (err) {
            console.error("addEducationDetails" + JSON.stringify(err));
          }
        }
      );
    }
  };

  return (
    <div className="basicinfo_container min-sm:col-span-2 max-sm:-mt-[120px] ">
      <div className="Container-box t-sal-margin-top">
        <div className=" bg-primary-white min-sm:rounded-xl shadow-lg pt-12 mb-8 p-3">
          <div className="col-sm-12">
            <div>
              <div className="addexperience right">
                <div className="skill-header">
                  <div>
                    <div className="profile-card-title">
                      <Label className="font-bold card-title-experience t-h2-font-sm">
                        {educationId !== ""
                          ? "Update Education"
                          : "Add Education"}
                      </Label>
                      <div className="horizontal_line" />
                    </div>
                  </div>
                </div>
                <Form className="mt-4">
                  <FormGroup row>
                    <Colxx sm={8}>
                      <FormGroup>
                        <Label>Education Type*</Label>
                        <Input
                          className="t-rounded-lg"
                          value={educationType}
                          type="select"
                          onChange={handleEducationSelectChange}
                        >
                          <option value="">Please select</option>
                          {educationTypeOptions.map(({ value, key }) => (
                            <option value={key} key={key}>
                              {value}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Colxx>

                    <Colxx sm={8}>
                      <FormGroup>
                        <Label data-testid="candidateaddeducation-forms.name">
                          Major*
                        </Label>

                        <Input
                          className="t-rounded-lg"
                          type="text"
                          data-testid="candidateaddeducation-majortype"
                          name="majortype"
                          onChange={inputsHandler}
                          value={inputField.majortype}
                          maxLength={255}
                        />
                      </FormGroup>
                    </Colxx>

                    <Colxx sm={8}>
                      <FormGroup>
                        <Label>School*</Label>
                        <Input
                          className="t-rounded-lg"
                          type="text"
                          data-testid="candidateaddeducation-school"
                          name="school"
                          onChange={inputsHandler}
                          value={inputField.school}
                        />
                      </FormGroup>
                    </Colxx>

                    <Colxx sm={12}>
                      <Row>
                        <Colxx sm={4}>
                          <FormGroup>
                            <Label>Start date</Label>
                            <div>
                              <DatePicker
                                className="form-control t-rounded-lg"
                                selected={startDate}
                                onChange={setStartDate}
                                dateFormat="MM/yyyy"
                                maxDate={new Date()}
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                showMonthYearPicker
                                dropdownMode="select"
                              />
                            </div>
                          </FormGroup>
                        </Colxx>

                        <Colxx sm={4}>
                          <FormGroup>
                            <Label>End date*</Label>
                            <DatePicker
                              className="form-control t-rounded-lg"
                              selected={endDate}
                              onChange={setEndDate}
                              dateFormat="MM/yyyy"
                              maxDate={new Date()}
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              showMonthYearPicker
                              dropdownMode="select"
                            />
                          </FormGroup>
                        </Colxx>
                      </Row>
                    </Colxx>
                    <Colxx sm={12}>
                        <Label>Address </Label>
                    </Colxx>
                    <Colxx sm={8}>
                    <FormGroup>
                       <GooglePlacesComponent parentCallback={handleCallback} />
                       </FormGroup>
                    </Colxx>
                    <Colxx sm={12}>
                      <Row>
                        <Colxx sm={4}>
                          <FormGroup>
                            <Label>City*</Label>
                            <Input
                              type="text"
                              className="t-rounded-lg"
                              data-testid="candidateaddeducation-city"
                              name="city"
                              onChange={inputAddressHandler}
                              value={inputAddressField.city}
                            />
                          </FormGroup>
                        </Colxx>

                        <Colxx sm={4}>
                          <FormGroup>
                            <Label>State*</Label>
                            <Input
                              className="t-rounded-lg"
                              type="text"
                              data-testid="candidateaddeducation-state"
                              name="state"
                              onChange={inputAddressHandler}
                              value={inputAddressField.state}
                            />
                          </FormGroup>
                        </Colxx>
                      </Row>
                    </Colxx>
                    <Colxx sm={12}>
                      <Row>
                        <Colxx sm={4}>
                          <FormGroup>
                            <Label>Zipcode </Label>
                            <Input
                              type="text"
                              className="t-rounded-lg"
                              data-testid="candidateaddeducation-zipcode"
                              name="zipcode"
                              onChange={inputAddressHandler}
                              value={inputAddressField.zipcode}
                            />
                          </FormGroup>
                        </Colxx>

                        <Colxx sm={4}>
                          <FormGroup>
                            <Label>Country*</Label>
                            <Select
                              className="t-rounded-lg"
                              value={country}
                              type="select"
                              onChange={handleCountrySelectChange}
                              options={countries}
                            ></Select>
                          </FormGroup>
                        </Colxx>
                      </Row>
                    </Colxx>
                    <Colxx sm={12}>
                      <FormGroup>
                        <Label>Description</Label>
                        <Input
                          rows="6"
                          className="t-rounded-lg"
                          data-testid="candidateaddeducation-description"
                          type="textarea"
                          name="description"
                          onChange={inputsHandler}
                          value={inputField.description}
                        />
                      </FormGroup>
                    </Colxx>
                  </FormGroup>
                </Form>

                <div>
                  {candidateSkills.length > 0 && (
                    <Row>
                      <Colxx sm={12}>
                        <Card>
                          <CardBody>
                            <CardTitle>
                              <strong>Skills</strong>
                              <p> Select skills relevant to this education</p>
                            </CardTitle>
                            {candidateSkills.length > 0 &&
                              candidateSkills.map((skill, index) => {
                                return (
                                  <div key={index} className="tracbox">
                                    <label className="terms">
                                      <input
                                        id={skill.skillId}
                                        type="checkbox"
                                        name={skill.name}
                                        className="input_skill t-rounded-lg"
                                        checked={selectedSkills.includes(skill.skillId)}
                                        onChange={(e) =>
                                          handleSkillCheck(e, skill)
                                        }
                                      />{" "}
                                      {skill.name}
                                    </label>
                                  </div>
                                );
                              })}
                            <p>
                              If you would like to add skills, first save this
                              education, go to Add Skills, and come back here by
                              clicking Education.{" "}
                            </p>
                          </CardBody>
                        </Card>
                      </Colxx>
                    </Row>
                  )}

                  {certificationsList.length > 0 && (
                    <Row className="mt-2">
                      <Colxx sm={12}>
                        <Card>
                          <CardBody>
                            <CardTitle>
                              <strong>Certifications</strong>
                            </CardTitle>
                            <p>
                              {" "}
                              Select certifications relevant to this education
                            </p>
                            {certificationsList.length > 0 &&
                              certificationsList.map((cerification, index) => {
                                return (
                                  <div key={index} className="tracbox">
                                    <label className="terms">
                                      <input
                                        id={cerification.skillId}
                                        type="checkbox"
                                        className="input_skill t-rounded-lg"
                                        checked={selectedSkills.includes(cerification.skillId)}
                                        onChange={(e) =>
                                          handleCerificationCheck(
                                            e,
                                            cerification
                                          )
                                        }
                                      />{" "}
                                      {cerification.name}{" "}
                                    </label>
                                  </div>
                                );
                              })}
                            <p>
                              If you would like to add certifications, first
                              save this education, go to Add Certifications, and
                              come back here by clicking Education.{" "}
                            </p>
                          </CardBody>
                        </Card>
                      </Colxx>
                    </Row>
                  )}
                </div>

                <div className="mt-4">
                  <TeamanicsButton
                    onClick={close}
                  >
                    Cancel
                  </TeamanicsButton>
                  <TeamanicsButton
                    className="ml-2"
                    disabled={saveBtnEnabled}
                    onClick={submitButton}
                  >
                    {educationId !== ""
                      ? "Update"
                      : "Save"}
                  </TeamanicsButton>
                </div>
              </div>
              <div className="mb-5"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateAddEducation;
